<template>
  <div class="processing">
    <div
      v-for="step in steps"
      :key="step.num"
      class="processing-step"
      :class="{
        active: currentStep === step.num && !completedSteps.includes(step.num),
        done: completedSteps.includes(step.num)
      }"
    >
      <div class="indicator">
        <template v-if="completedSteps.includes(step.num)"></template>
        <template v-else>{{ step.num }}</template>
      </div>
      <span v-if="step.num === 1 && completedSteps.includes(1) && woz">
        <strong>{{ t('processing.wozFound') }}</strong> {{ formatEuro(woz.waarde) }} <span class="ps-meta">({{ t('processing.wozDate') }} {{ woz.peildatum }})</span>
      </span>
      <span v-else>{{ t(step.key) }}</span>
    </div>
  </div>
</template>

<script setup>
import { useBerekening } from '@/composables/useBerekening'
import { useLocale } from '../composables/useLocale'

const { formatEuro } = useBerekening()
const { t } = useLocale()

defineProps({
  woz: { type: Object, default: null },
  currentStep: { type: Number, default: 0 },
  completedSteps: { type: Array, default: () => [] }
})

const steps = [
  { num: 1, key: 'processing.step1' },
  { num: 2, key: 'processing.step2' },
  { num: 3, key: 'processing.step3' },
  { num: 4, key: 'processing.step4' },
  { num: 5, key: 'processing.step5' },
]
</script>

<style scoped>
.processing {
  max-width: 720px;
  margin: 32px auto 0;
  background: var(--bg-card);
  border: 1px solid var(--line-soft);
  padding: 36px 40px;
  border-radius: 24px;
  box-shadow: var(--shadow-soft);
}
.processing-step {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  font-size: 16px;
  color: var(--ink-muted);
  transition: color 0.3s;
}
.processing-step.active { color: var(--ink); font-weight: 600; }
.processing-step.done { color: var(--good); }
.processing-step .indicator {
  width: 26px;
  height: 26px;
  border: 2px solid var(--line-soft);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  transition: all 0.3s;
  color: var(--ink-muted);
}
.processing-step.active .indicator {
  border-color: var(--blue);
  background: var(--blue);
  color: white;
  animation: spin 1s linear infinite;
}
.processing-step.done .indicator {
  border-color: var(--good);
  background: var(--good);
  color: white;
  animation: none;
}
.processing-step.done .indicator::after { content: '\2713'; }
.processing-step.active .indicator::after {
  content: '';
  border: 2px solid white;
  border-top-color: transparent;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  display: block;
}
.ps-meta {
  color: var(--ink-muted);
  font-weight: 400;
  font-size: 13px;
  margin-left: 4px;
}
</style>
